import { Container, Row, Col } from 'react-bootstrap';
import { litrals } from '../../../../../../../constants/Litrals';

const HowItWorks = () => {
  return (
    <Container className="subscriber-container">
      <Row className="justify-content-center">
        <Col xs={12} md={8}>
          <h3 data-testid="how-it-works">{litrals.subscriberHowItWorks}</h3>
          <div className="subscriber-content">
            <p>
              The data is available in DATEX II format which is a European XML
              standard for traffic information. This service uses
              industry-standard web services to push data to subscribers within
              one minute of collection from the roadside. Subscribers should be
              capable of developing software to receive the raw data in DATEX II
              format.
            </p>
            <h6>Please note:</h6>
            <p>
              When a Subscriber has configured a data feed, by inputting their
              Endpoint URL, Username and Password, the data will not be sent
              straight away as some checks have to be carried out. These checks
              make sure that, at a minimum, we can connect to the endpoint and
              send a test payload. Whilst these checks are being performed the
              Data Feed will have a ‘Pending’ status. Once the checks are
              completed, the status of the Data Feed will change to ‘Active’.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
export default HowItWorks;
